<template>
  <div :class="{'nestable-table-row': true, 'nestable-table-row-striped': striped}">
    <div :class="['nestable-table-cell', 'nestable-table-cell-control', editing ? 'nestable-table-row-handle' : '']">
      <i class="fas fa-grip-vertical" v-if="editing"></i>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NestableTableRow',
  props: {
    editing: Boolean,
    striped: {
      type: Boolean,
      default: false
    }
  }
}
</script>